export const LIST_GROUPS = 'LIST_GROUPS';
export const LIST_GROUPS_LOADING = 'LIST_GROUPS_LOADING';
export const  GROUP_USER_LIST_LOADING = 'GROUP_USER_LIST_LOADING';
export const  GROUP_USER_LIST = 'GROUP_USER_LIST';